const DEFAULT_FOOTER_STYLE = {
    paragraphLineHeight: undefined,
    fontColor: '#2D2D2D',
    fontSize: '13px',
    lineHeight: '2.1em',
    textAlign: 'center',
    linkPadding: '0 8px',
};
export const minifyHtmlString = (html) => {
    return html
        .split('\n')
        .map((s) => s.trim())
        .join('');
};
export const formatFooter = (lines) => {
    return minifyHtmlString(`<div class="so-global-p1">
        ${lines.join('\n')}
      </div>`);
};
export const getClassicFooterHtmlBlocks = ({ content, styleOverrides = {}, }) => {
    const { dontReply, helpCenter, helpCenterUrl, privacyPolicy, privacyPolicyUrl, termsOfUse, termsOfUseUrl, companyAddressLine, } = content ?? {};
    const style = { ...DEFAULT_FOOTER_STYLE, ...styleOverrides };
    const commonStyle = `line-height: ${style.lineHeight}; color: ${style.fontColor}; font-size: ${style.fontSize}`;
    const getStyledWrapper = (innerHtml) => {
        const styles = [
            `text-align: ${style.textAlign}`,
            style.paragraphLineHeight && `line-height: ${style.paragraphLineHeight}`,
        ]
            .filter(Boolean)
            .join('; ');
        return `<p style="${styles}" class="so-global-p1">${innerHtml}</p>`;
    };
    const getSingleLine = (text) => getStyledWrapper(`<span style="${commonStyle}">${text}</span>`);
    const getLinkTag = (text, url, divider) => {
        const dividerStyle = divider
            ? `border-${divider}: 1px solid ${style.fontColor}`
            : 'border: none';
        return `<a target="_blank" rel="noopener noreferrer" href="${url}">
      <span style="text-decoration: underline; ${commonStyle};${dividerStyle}; padding: ${style.linkPadding};">
        ${text}
      </span>
    </a>`;
    };
    const dontReplyLine = dontReply ? getSingleLine(dontReply) : '';
    const addressLine = companyAddressLine
        ? getSingleLine(companyAddressLine)
        : '';
    const links = [
        [helpCenter, helpCenterUrl],
        [privacyPolicy, privacyPolicyUrl],
        [termsOfUse, termsOfUseUrl],
    ].filter((linkParams) => Boolean(linkParams[0] && linkParams[1]));
    const linkTags = links.map(([text, url], i) => {
        const isLastLink = i === links.length - 1;
        return getLinkTag(text, url, isLastLink ? undefined : 'right');
    });
    const linksLine = linkTags.length > 0 ? getStyledWrapper(linkTags.join('\n')) : '';
    return { addressLine, linksLine, dontReplyLine };
};
//# sourceMappingURL=utils.js.map